/**
 * Normalize driver ID from order (string _id or populated object { _id }).
 * Used so driverStats keys match driver.id / driver._id lookups.
 */
export function toDriverKey(raw) {
  if (raw == null) return null;
  if (typeof raw === 'object' && raw !== null && '_id' in raw) return String(raw._id);
  return String(raw);
}

/**
 * Build { [driverKey]: { orderCount, lastOrderDate, lastOrderAddress } } from completed orders.
 * Only counts orders where order.status === 'completed' (all past completed deliveries).
 */
export function buildDriverStats(completedOrders) {
  const driverStats = {};
  completedOrders.forEach((o) => {
    if (o.status !== 'completed') return;
    const key = toDriverKey(o.driverID ?? o.driverId);
    if (key) {
      if (!driverStats[key]) {
        driverStats[key] = { orderCount: 0, lastOrderDate: null, lastOrderAddress: null };
      }
      driverStats[key].orderCount++;
      const orderDate = o.inStockDate ? new Date(o.inStockDate) : null;
      if (orderDate && (!driverStats[key].lastOrderDate || orderDate > new Date(driverStats[key].lastOrderDate))) {
        driverStats[key].lastOrderDate = orderDate.toISOString();
        driverStats[key].lastOrderAddress =
          o.property?.address?.line1 ? `${o.property.address.line1}, ${o.property.address.city}` : null;
      }
    }
  });
  return driverStats;
}

/**
 * Resolve stats for a driver (by d.id or d._id). Returns { orderCount, lastOrderDate, lastOrderAddress }.
 */
export function getDriverStats(driver, driverStats) {
  const driverKey = driver.id != null ? String(driver.id) : (driver._id != null ? String(driver._id) : null);
  return (driverKey && driverStats[driverKey]) ? driverStats[driverKey] : { orderCount: 0, lastOrderDate: null, lastOrderAddress: null };
}
